<div
  class="select"
  [class.select--error]="isErrorShown()"
  [class.select--disabled]="disabled()"
  [class.select--left-icon]="prefixIcon()"
  [class.select--small]="size() === 'small'"
>
  @if (label()) {
    <label class="select__label">
      {{ label() }}
      @if (required()) {
        <span class="select__label-asterisk">*</span>
      }
    </label>
  }

  <div class="select-input-wrapper">
    @if (prefixIcon(); as icon) {
      <span class="select-input-wrapper__leftIcon">
        <fr8bot-ui-icon [name]="icon" [size]="16" />
      </span>
    }

    <ng-select
      class="select__input"
      data-testid="select-field-control"
      appendTo="body"
      bindLabel="name"
      bindValue="value"
      [formField]="selectField"
      [items]="options()"
      [placeholder]="placeholder() | translate"
      [fixedPlaceholder]="false"
      [multiple]="multiple()"
      [searchable]="false"
      (open)="isOpen.set(true)"
      (close)="isOpen.set(false)"
      (blur)="touch.emit()"
    >
      <ng-template ng-multi-label-tmp>
        <div class="multi-select-text" [class.multi-select-text__with-padding]="prefixIcon()">
          {{ value() | multiValueText: options() }}
        </div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div class="select__option" data-testid="select-field-option">
          @if (showCheckmark()) {
            <span
              [class.visible]="item.value | showOptionCheckmark: value()"
              class="select-option-checkmark"
            >
              <fr8bot-ui-icon name="checkmark-16" [size]="16" />
            </span>
          }

          @if (item.flag) {
            <fr8bot-ui-flag-icon class="tw:mr-2" [country]="item.flag" />
          }

          @if (item.icon) {
            <span class="select-option-icon">
              <fr8bot-ui-icon [name]="item.icon" [size]="16" />
            </span>
          }

          <span class="select-option-text">
            <span class="select-option-text__title">
              {{ item.name }}
            </span>
            @if (item.description) {
              <span class="select-option-text__subtitle">
                {{ item.description }}
              </span>
            }
          </span>
        </div>
      </ng-template>
    </ng-select>
    <span class="select-input-wrapper__actions">
      @if (selectedFlag(); as flag) {
        <span class="tw:flex tw:h-full tw:items-center">
          <fr8bot-ui-flag-icon [country]="flag" [width]="24" [height]="18" />
        </span>
      }
      @if (!value() || multiple() || !canClear() || disabled()) {
        <span
          class="select-input-wrapper__arrow tw:flex tw:w-[var(--field-action-size,48px)] tw:h-full tw:shrink-0 tw:items-center tw:justify-center"
          [class.select-input-wrapper__arrow--open]="isOpen()"
        >
          <fr8bot-ui-icon name="arrow-down-12" [size]="12" />
        </span>
      } @else {
        <button uiFieldAction="danger" (click)="clearState()">
          <fr8bot-ui-icon name="x-1-12" [size]="12" />
        </button>
      }
    </span>
  </div>

  @if (isErrorVisible()) {
    <div>
      <fr8bot-ui-validation-error [error]="error()" />
      @if (errorRef()) {
        <ng-content></ng-content>
      }
    </div>
  }
</div>
